import { TSelectOption } from '@interfaces/components/componentTypes';
import { TTableFilter } from '@interfaces/components/table';
import { IConnectionLogsFilter } from '@interfaces/middlewareSMO/connectionLogs';

import { MIN_FILTER_WIDTH } from '@constants/common';

export const generateConnectionLogsFilters = (
	options: IConnectionLogsFilter[],
	selectedFilters: Record<string, TSelectOption>,
	setSelectedGeneratedFilters: (value: Record<string, TSelectOption>) => void,
): TTableFilter[] => {
	return options.map((filter) => ({
		name: filter.name,
		placeholder: filter.placeholder,
		option: selectedFilters[filter.name] || null,
		options: filter.data,
		minWidth: MIN_FILTER_WIDTH,
		setState: (option: TSelectOption<string>) => {
			setSelectedGeneratedFilters({ [filter.name]: option?.value !== undefined ? option : null });
		},
		defaultValue: null,
	}));
};

export const getConnectionLogsFilterValues = (
	filters: Record<string, TSelectOption>,
): Record<string, string> => {
	return Object.entries(filters).reduce((acc, [key, option]) => {
		const filter = option?.value !== undefined ? { [key]: option.value } : null;

		return filter
			? { ...acc, ...filter }
			: acc;
	}, {});
};
